export enum SignInDialogVersion {
    V1,
    V2,
}
